import { CallStatus } from '@/types/enums/CallStatus';

export interface CallStatusCount {
    [CallStatus.ANSWERED]: number;
    [CallStatus.NO_ANSWER]: number;
    [CallStatus.BUSY]: number;
    [CallStatus.DITCHED]: number;
}
